const getPercentageProgress = (current, max) => Math.round((current * 100) / max);

export default getPercentageProgress;